import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { MdAccountCircle } from 'react-icons/md';
import Moment from 'react-moment';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import moment from 'moment';


const StyledSection4 = styled.div`
    position: relative;
    width: 100%;
    transition: all .5s ease-in-out;
    margin-bottom: 3rem;
    padding: 1rem 1.75rem;
    background-color: ${({ theme }) => theme.colors.background.elements};
    border-radius: 0.75rem;
    position: relative;
    border: 1px solid #ccc;

    
    .infoTitle{
        width: 8rem;
    }
    .infoData{
        color: ${({ theme }) => theme.colors.text.primary};
    }
    .scroll-thumb{
        background-color: ${({ theme }) => theme.colors.primary_8};
    }
`;

const Section4 = ({ contractData }) => {

    return (
        <StyledSection4>
            <h2 className='sectionFloatTitle'>اطراف العقد</h2>

            <Row className='mt-2'>
                <Col className='mb-2'>
                    <p>
                        <span className='infoTitle'>
                            <MdAccountCircle className='icon' />المؤجر :
                        </span>
                        <span className='infoData'>
                            {contractData.owner}
                        </span>
                    </p>
                    <p>
                        <span className='infoTitle'>
                            هوية وطنية :
                        </span>
                        <span className='infoData'>
                            124578235689#
                        </span>
                    </p>
                </Col>
                <Col className='mb-2'>
                    <p>
                        <span className='infoTitle'>
                            <MdAccountCircle className='icon' />المستأجر :
                        </span>
                        <span className='infoData'>
                            {contractData.Tenant}
                        </span>
                    </p>
                    <p>
                        <span className='infoTitle'>
                            هوية وطنية :
                        </span>
                        <span className='infoData'>
                            951753456248#
                        </span>
                    </p>
                </Col>
            </Row>
        </StyledSection4>
    );
}

export default Section4;